var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return !_vm.doneFetching
    ? _c("StudipProgressIndicator", {
        staticClass: "loading-indicator-content",
        attrs: {
          description: _vm.$gettext("Lade Kommentare..."),
        },
      })
    : _vm.thread
    ? _c(
        "div",
        {
          staticClass: "blubber_panel",
        },
        [
          _c(
            "div",
            {
              attrs: {
                id: "blubber_stream_container",
              },
            },
            [
              _c("BlubberThread", {
                ref: "thread",
                attrs: {
                  comments: _vm.comments,
                  thread: _vm.thread,
                  moreCommentsDown: _vm.moreCommentsDown(_vm.thread.id),
                  moreCommentsUp: _vm.moreCommentsUp(_vm.thread.id),
                  uploadProgress: _vm.uploadProgress,
                },
                on: {
                  "load-older": _vm.onLoadOlder,
                  "load-newer": _vm.onLoadNewer,
                  "add-posting": _vm.onAddPosting,
                  "change-comment": _vm.onChangeComment,
                  "pick-files": _vm.onPickFiles,
                  "remove-comment": _vm.onRemoveComment,
                  "subscribe-thread": _vm.onSubscribeThread,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("BlubberSideInfo", {
            attrs: {
              thread: _vm.thread,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }